<template>
  <ExportList></ExportList>
</template>

<script>
export default {
  name: 'ExportListPage'
}
</script>

<style>

</style>